let invoicesSidePanel = $('#data-side-panel-invoice-selector');

if (invoicesSidePanel.length) {
    invoicesSidePanel
        .bind('nc.sidePanel.shown', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
        })
        .bind('nc.sidePanel.reloaded', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
        });

    function registerSelect(sidePanel) {
        sidePanel.content.find('tbody tr').click((e) => {
            if ($(e.target).closest('a').length > 0) {
                return;
            }

            let row = $(e.target).closest('tr');
            let number = row.find('td[data-column="invoice_number"]').text().trim()

            if (sidePanel.target.is('i')) {
                sidePanel.target = sidePanel.target.parent();
            }

            if (sidePanel.target.is('button')) {
                sidePanel.loader.open();
                // setTimeout(() => {
                confirm('Wilt u zeker dat u factuur "' + number + '" wil koppelen?', () => {
                    let form = sidePanel.target
                        .closest('form');
                    form.find('input[type="hidden"][name="invoice_id"]')
                        .val(row.data('primary-key'))
                        .trigger('change');
                    form.submit();
                }, () => {
                    sidePanel.loader.close()
                })
                // })
            } else {
                let text = row.find('td[data-column="name"], td[data-column="title"]')

                if (text.length) {
                    text = text.first().text();
                } else {
                    text = row.children().first().text()
                }
                sidePanel.target
                    .closest('.input-group')
                    .find('input[type="hidden"]')
                    .val(row.data('primary-key'))
                    .trigger('change');
                sidePanel.target
                    .closest('.input-group')
                    .find('input[type="text"]')
                    .val(text.trim())
                    .trigger('change');
                sidePanel.close();
            }
        });
    }

}
